import { Box, useColorModeValue, Text } from "@chakra-ui/react";
import type { FunctionComponent } from "react";
import React from "react";
import type { Message } from "types/conversation";
import { ChatBubble, MessageContainer } from "../components";
import { ShowMoreContainer } from "screens/common/components/ShowMoreContainer";
import { MarkdownViewer } from "screens/markdown/MarkdownViewer";
import type { QuestionAnswer } from "types/charliui";

interface Props {
  message: Message;
  datum: QuestionAnswer;
}

export const QuestionAnswerCell: FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({ message, datum }) => {
  const charliBgColor = useColorModeValue("gray.100", "#161B25");
  const questionBgColor = useColorModeValue("#bae399", "#1a3b48");

  return (
    <MessageContainer initiator={message.senderId === "charli" ? "charli" : "user"} key={`${message.id}-question-answer`}>
      <Box position="relative">
        <ChatBubble
          maxCellHeight="100%"
          className="ch-question-answer-cell"
          initiator={message.senderId === "charli" ? "charli" : "user"}
          state={message.state}>
          <ShowMoreContainer height="15.5rem" minHeight="17rem">
            <Box bgColor={questionBgColor} p=".5rem" rounded="md" mb="1rem">
              <Text fontWeight={"semibold"} fontStyle={"italic"}>
                {datum.body.question}
              </Text>
            </Box>
            <MarkdownViewer backgroundColor={charliBgColor} content={datum.body.answer} fontSize="xs" />
          </ShowMoreContainer>
        </ChatBubble>
      </Box>
    </MessageContainer>
  );
};
